import { createSlice } from "@reduxjs/toolkit";

const verifyaffiliateSlice = createSlice({
  name: "verifyAffiliate",
  initialState: {
    isVerifyAffiliateOpen: false,
  },
  reducers: {
    toogleVerifyAffiliate: (state) => {
      state.isVerifyAffiliateOpen = !state.isVerifyAffiliateOpen;
    },
  },
});

export const { toogleVerifyAffiliate } = verifyaffiliateSlice.actions;
export default verifyaffiliateSlice.reducer;